function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#0EFBA7",
  fillRule: "evenodd",
  d: "M1.864 3.914l2.464 2.364L10.035.914l1.414 1.415-7.121 6.777L.449 5.328z"
});
function SvgIconVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10"
  }, props), _ref);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='10' viewBox='0 0 12 10'%3e %3cpath fill='%230EFBA7' fill-rule='evenodd' d='M5 4L5.071 7.414 12.899 7.657 12.899 9.657 3.071 9.414 3 4z' transform='rotate(-45 3.328 7.743)'/%3e %3c/svg%3e";
export { SvgIconVerified as ReactComponent };